import React, {useEffect,useState} from "react";
import {Container, Row, Col, Button,  Nav, NavDropdown, Dropdown, Navbar, Tab, Tabs, ProgressBar, Accordion,   } from "react-bootstrap";
import '../assets/css/style.css';
import './style.css';
import Logo from '../assets/images/bulk-logo.png';
import LineBg from '../assets/images/line-bg.png';
import ParnterBg from '../assets/images/partner-bg.png';
//banner
import SupportGraph from '../assets/images/support-graph.png'
import FC from '../assets/images/fc.png'

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
//partners logo's
import P1 from './PartnersLogo/partner1.png';
import P2 from './PartnersLogo/partner2.png';
import P3 from './PartnersLogo/partner3.png';
import P4 from './PartnersLogo/partner4.png';
import P5 from './PartnersLogo/partner5.png';
import P6 from './PartnersLogo/partner6.png';
import P7 from './PartnersLogo/partner7.png';
import P8 from './PartnersLogo/partner8.png';
import P9 from './PartnersLogo/partner9.png';
import P10 from './PartnersLogo/partner10.png';
import P11 from './PartnersLogo/partner11.png';
import P12 from './PartnersLogo/partner12.png';
//utils function 
import { isFinished, isActive, isUpcoming, getDealStauts } from "./utils";


function LandingPage (){

  const[allPublicDeals,setAllPublicDeals] = useState([{}]);
  const[customData,setCustomData] = useState({id: "",
  name: "",
  description: "",
  joinlink: "",
  logo:"",
  upcomingDealHide:true,
  joinlinkHide: true
  });
  const[tabKey,setTabKey] = useState("all-deal");

  async function loadCustom(){
    await fetch('https://ido-api-services.herokuapp.com/landing-pages/61fcd524559e673c3472eb6a?filter={"offset": 0,"limit": 100,"skip": 0,"order": "string","fields": {"id": true,"name": true,"description": true,"logo": true,"joinlink": true, "upcomingDealHide": true, "joinlinkHide": true}}').then(res=>res.json()).then(
      (result)=>{
        // console.log(result);
        setCustomData(result);
      }
    )
  }

  async function loadPublicDeals(){
    //"VisibleInAll": true
    await fetch('https://ido-api-services.herokuapp.com/get-all-deals?filter={"offset": 0,"order": "LastUpdate DESC","where": {"VisibleInAll": true},"fields": {"Name": true,"id": true,"Ticker": true,"TotalRaize": true,"Currency": true,"Start": true,"End": true,"AllocationForTier1": true,"AllocationForTier4": true,"CurrentRaize": true}}').then(res=>res.json()).then(
      (result)=>{
        // console.log(result)
        if(result.success){
          if(tabKey=="all-deal"){ //set all deals
            setAllPublicDeals(result.res);
          }else{
            let data=[];
            if(tabKey=="active"){ //set active deals only
              result.res.forEach((item) => {
                if(isActive(item.Start,item.End)){
                  data.push(item);
                }
              }); 
            } else if(tabKey=="upcoming"){ //set upcoming deals only
              result.res.forEach((item) => {
                if(isUpcoming(item.Start)){
                  data.push(item);
                }
              }); 
            } else if(tabKey=="finished"){ //set finished deals only
              result.res.forEach((item) => {
                if(isFinished(item.End)){
                  data.push(item);
                }
              }); 
            }
          setAllPublicDeals(data);
          }
        }
      }
    )
  }
  
  useEffect(()=>{
    loadPublicDeals();
    loadCustom();
    
    // FAQ handling
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
          acc[i].addEventListener("click", function() {
            this.classList.toggle("show");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
              panel.style.maxHeight = null;
            } else {
              panel.style.maxHeight = panel.scrollHeight + "px";
            } 
          });
        }
  },[]); 

  useEffect(()=>{
    // setAllPublicDeals([{}]);
    loadPublicDeals();
    },[tabKey]);  

  
  const GetDealLogo= (props)=>{
    const [imageData,setImageData]= useState(null);
    useEffect(()=>{
        if(props.id){
            fetch('https://ido-api-services.herokuapp.com/get-single-deal/'+props.id+'?filter={"fields": {"Icon": true}}').then(res=>res.json()).then(
            (result)=>{
                if(result.success){
                  setImageData("data:image/png;base64,"+result.res.Icon);
                }
            })
        }
    },[props.id]);
    
    return(<>
    {imageData?<img src={imageData}/>:<img src={imageData} hidden={true}/>}
    </>)
    
  }

  // predefined data
const project = {
  margin:10,
  responsiveClass:true,
  nav:true,
  loop:true, //(allPublicDeals.length>1),
  autoplay: false,
  smartSpeed: 1000,
  responsive: {
      0: {
          items: 1,
      },
      400: {
          items: 1,
      },
      700: {
          items: 1,
      },
     900: {
          items: 2,
      },
      1000: {
          items:3,
      },
      1199: {
        items:5,
    }
  
  },
};

const partner = {
  margin:5,
  responsiveClass: true,
  nav: false,
  autoplay: true,
  smartSpeed: 1000,
  loop:true,
  dots: false,
  responsive: {
      0: {
          items: 1,
      },
      500: {
          items: 1,
      },
      600: {
          items: 2,
      },
      700: {
          items: 2,
      },
      1199: {
          items:6,
      }
  
  },
};

return(
<div className="landing-page">
<header>
<Navbar  expand="lg">
  <Container>
    <Navbar.Brand href="#home"> <img src={Logo} className="logo-homepage" /> <span> Bulk </span></Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    <Navbar.Collapse id="basic-navbar-nav">
      <Nav className="me-auto">
        <Nav.Link href="https://bulklock.web.app/">Platform</Nav.Link>
        <Nav.Link href="https://drive.google.com/file/d/1V0f95QD0Fb5MM9aZeGHhNzQHisXxJDRf/view">Pitch Deck</Nav.Link>
        <Nav.Link href="https://crosschainbridge.org/#/bridge">ETH BSC Bridge</Nav.Link>
        <Nav.Link href="https://t.me/Bulk_Nation">Community</Nav.Link>
        <Nav.Link href="mailto:info@bulknetwork.xyz">Contact</Nav.Link>
        </Nav>
      <a href="https://crypto-bulk-intl.medium.com/how-to-join-bulk-community-7759b722ac21" target="_blank"><button className="btn-main hrd">Get started</button></a>
      <a href="https://forms.gle/96LVzB1FcTZiew4W6" target="_blank" style={{marginLeft:"10px"}}><button className="white-btn"> Suggest project</button></a>
    </Navbar.Collapse>

  </Container>
</Navbar>
</header>

<div className="banner">

<svg width="439" height="660" viewBox="0 0 439 660" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.4" filter="url(#filter0_f_465_11)">
<circle cx="109" cy="330" r="130" fill="#7F68DB"/>
</g>
<defs>
<filter id="filter0_f_465_11" x="-221" y="0" width="660" height="660" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_465_11"/>
</filter>
</defs>
</svg>



<Container>
<div className="banner-content">
<div className="content">
<p className="best-deal" hidden={customData.upcomingDealHide}>upcoming deal</p>
<h1 className="axiforma-font" dangerouslySetInnerHTML={{__html: customData.name}}></h1>
<p className="axiforma-font" dangerouslySetInnerHTML={{__html: customData.description}}></p>
<a href={customData.joinlink} hidden={customData.joinlinkHide}><button className="gr-button">Join the  deal</button></a>
  <div className="buy-btn-row">
    <p>Buy $BULK on</p> 
    <a href="https://app.uniswap.org/#/swap?outputCurrency=0xa143ac515dca260a46c742c7251ef3b268639593" target="_blank">
      <button className="red-button">Uniswap</button> 
    </a>
    <a href="https://pancakeswap.finance/swap?outputCurrency=0xa143ac515dca260a46c742c7251ef3b268639593" target="_blank">
      <button className="orange-button">Pancakeswap</button>      
    </a>
  </div> 
</div>

</div>
</Container>
<img src={customData.logo?"data:image/png;base64,"+customData.logo:""} className="banner-img" />
</div> {/* ====================  banner closed ==================== */}


<section div className="project-section ">
<Container fluid>
<div className="main-page-heading">
<p>PUBLIC AREA</p>  
<h2>Projects</h2>
<div>
<p>The majority of our deals are visible in the members’ area only and are not displayed here</p>
</div>
</div>
{/* heading closed */}

<Tabs activeKey={tabKey} onSelect={(k) => setTabKey(k)} className="mb-3">
  <Tab eventKey="all-deal" title="All Deals">

  <div className="book-slider-main">
      {allPublicDeals.length===0?
        <><p>No deals available....</p></>
        :
        <>
        <OwlCarousel className='owl-theme user-book'  key={allPublicDeals.length} {...project} >
        {allPublicDeals.map((data, key) => {
          return(
              <div class='item'>
                <div className="all-deal-box home-deal-box">
                  <div className="cnt-box">
                <Row className=" header-chart align-items-center">
                  <Col md={12}>
                  <div className="user-name-row dl-dt">
                    <GetDealLogo id={data.id}/>
                  <div>
                  <p>{data.Name} </p>
                  <p className="small-text">{data.Ticker}</p>
                  </div>
                  </div> 
                  </Col>
                </Row>
                <Row >
                  <Col md={12}>
                  <div class="deal-info">
                  <ul>
                  <li><span className='text-heading'>Max Allocation</span> <span>{data.AllocationForTier1} {data.Currency}</span></li>  
                  <li><span className='text-heading'>Min Allocation</span>  <span>{data.AllocationForTier4} {data.Currency}</span></li>  
                  </ul>
                  </div>  
                  </Col> 
                </Row>
                <div>
                <Row>
                <Col md={12}>
                <div className="chart-box">
                <svg width="56" height="30" viewBox="0 0 56 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 28C4.41676 25.3389 7.63911 18.2204 13.2782 18.0208C18.9173 17.8212 23.1467 24.8066 28.9872 24.8066C34.8277 24.8066 37.4358 13.3385 44.6961 8.04155C48.107 5.55309 54.5646 0.457338 53.9604 2.45318" stroke="url(#paint0_linear_2_459)" stroke-width="3"/>
                <defs>
                <linearGradient id="paint0_linear_2_459" x1="53.9604" y1="2" x2="2.19124" y2="28.3221" gradientUnits="userSpaceOnUse">
                <stop stop-color="#587DFF" stop-opacity="0"/>
                <stop offset="0.535704" stop-color="#587DFF"/>
                <stop offset="1" stop-color="#587DFF" stop-opacity="0"/>
                </linearGradient>
                </defs>
                </svg>
                <div className="chart-box-content">
                  <p>Total Raize</p>
                  <p class="price-chart"><span>{data.TotalRaize}</span> {data.Currency}</p>
                </div>
                </div>
                </Col>

                <Col md={12}>
                <div className="chart-box">

                <div className="progress-bar-row">
                <p className="pr-percent">{(data.CurrentRaize/data.TotalRaize * 100).toFixed(2)}%</p>
                <ProgressBar now={data.CurrentRaize/data.TotalRaize * 100} />
                </div> 
                <div className="chart-box-content">
                <p>Status</p>
                <p class="price-chart"><i class="fa fa-circle" aria-hidden="true"></i>{getDealStauts(data.Start,data.End)}</p>
                </div>
                </div>
                </Col>
                </Row>
                </div> {/* all deal closed  */}
                </div>

                <div className="about-joindeal">
                {/* <p className="brdr-ab"><a href="#">About</a> </p> */}
                <p><a href={"https://bulknetwork.app/contribute/"+data.id}>View Deal</a> </p> 
                </div>

                </div>
              {/* ====================  all deal closed ==================== */}
              </div>
          )
        })}  
        </OwlCarousel>
        </>
      }
  <div className="see-all-buttn"><a href="https://bulknetwork.app/" target="_blank"><button className="cnt-button">See all</button></a></div>
  </div>


  </Tab>
  {/* ============================ all deals closed ====================================== */}


  <Tab eventKey="active" title="Active">

  <div className="book-slider-main">
      {allPublicDeals.length===0?
        <><p>No deals available....</p></>
        :
        <>
        <OwlCarousel className='owl-theme user-book' key={allPublicDeals.length}  {...project} >
        {allPublicDeals.map((data, key) => {
          return(
              <div class='item'>
                <div className="all-deal-box home-deal-box">
                  <div className="cnt-box">
                <Row className=" header-chart align-items-center">
                  <Col md={12}>
                  <div className="user-name-row dl-dt">
                    <GetDealLogo id={data.id}/>
                  <div>
                  <p>{data.Name} </p>
                  <p className="small-text">{data.Ticker}</p>
                  </div>
                  </div> 
                  </Col>
                </Row>
                <Row >
                  <Col md={12}>
                  <div class="deal-info">
                  <ul>
                  <li><span className='text-heading'>Max Allocation</span> <span>{data.AllocationForTier1} {data.Currency}</span></li>  
                  <li><span className='text-heading'>Min Allocation</span>  <span>{data.AllocationForTier4} {data.Currency}</span></li>  
                  </ul>
                  </div>  
                  </Col> 
                </Row>
                <div className="deal-box-inner">
                <Row>
                <Col md={12}>
                <div className="chart-box">
                <svg width="56" height="30" viewBox="0 0 56 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 28C4.41676 25.3389 7.63911 18.2204 13.2782 18.0208C18.9173 17.8212 23.1467 24.8066 28.9872 24.8066C34.8277 24.8066 37.4358 13.3385 44.6961 8.04155C48.107 5.55309 54.5646 0.457338 53.9604 2.45318" stroke="url(#paint0_linear_2_459)" stroke-width="3"/>
                <defs>
                <linearGradient id="paint0_linear_2_459" x1="53.9604" y1="2" x2="2.19124" y2="28.3221" gradientUnits="userSpaceOnUse">
                <stop stop-color="#587DFF" stop-opacity="0"/>
                <stop offset="0.535704" stop-color="#587DFF"/>
                <stop offset="1" stop-color="#587DFF" stop-opacity="0"/>
                </linearGradient>
                </defs>
                </svg>
                <div className="chart-box-content">
                  <p>Total Raize</p>
                  <p class="price-chart"><span>{data.TotalRaize}</span> {data.Currency}</p>
                </div>
                </div>
                </Col>

                <Col md={12}>
                <div className="chart-box">

                <div className="progress-bar-row">
                <p className="pr-percent">{(data.CurrentRaize/data.TotalRaize * 100).toFixed(2)}%</p>
                <ProgressBar now={data.CurrentRaize/data.TotalRaize * 100} />
                </div> 
                <div className="chart-box-content">
                <p>Status</p>
                <p class="price-chart"><i class="fa fa-circle" aria-hidden="true"></i>{getDealStauts(data.Start,data.End)}</p>
                </div>
                </div>
                </Col>
                </Row>
                </div> {/* all deal closed  */}
                </div>

                <div className="about-joindeal">
                {/* <p className="brdr-ab"><a href="#">About</a> </p> */}
                <p><a href={"https://bulknetwork.app/contribute/"+data.id}>View Deal</a> </p> 
                </div>

                </div>
              {/* ====================  all deal closed ==================== */}
              </div>
          )
        })}  
        </OwlCarousel>
        </>
      }
  <div className="see-all-buttn"><a href="https://bulknetwork.app/" target="_blank"><button className="cnt-button">See all</button></a></div>
  </div>

  </Tab>
    {/* ============================ active closed ====================================== */}


  <Tab eventKey="upcoming" title="Upcoming">
  
  <div className="book-slider-main">
      {allPublicDeals.length===0?
        <><p>No deals available....</p></>
        :
        <>
        <OwlCarousel className='owl-theme user-book' key={allPublicDeals.length}  {...project} >
        {allPublicDeals.map((data, key) => {
          return(
              <div class='item'>
                <div className="all-deal-box home-deal-box">
                  <div className="cnt-box">
                <Row className=" header-chart align-items-center">
                  <Col md={12}>
                  <div className="user-name-row dl-dt">
                    <GetDealLogo id={data.id}/>
                  <div>
                  <p>{data.Name} </p>
                  <p className="small-text">{data.Ticker}</p>
                  </div>
                  </div> 
                  </Col>
                </Row>
                <Row >
                  <Col md={12}>
                  <div class="deal-info">
                  <ul>
                  <li><span className='text-heading'>Max Allocation</span> <span>{data.AllocationForTier1} {data.Currency}</span></li>  
                  <li><span className='text-heading'>Min Allocation</span>  <span>{data.AllocationForTier4} {data.Currency}</span></li>  
                  </ul>
                  </div>  
                  </Col> 
                </Row>
                <div className="deal-box-inner">
                <Row>
                <Col md={12}>
                <div className="chart-box">
                <svg width="56" height="30" viewBox="0 0 56 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 28C4.41676 25.3389 7.63911 18.2204 13.2782 18.0208C18.9173 17.8212 23.1467 24.8066 28.9872 24.8066C34.8277 24.8066 37.4358 13.3385 44.6961 8.04155C48.107 5.55309 54.5646 0.457338 53.9604 2.45318" stroke="url(#paint0_linear_2_459)" stroke-width="3"/>
                <defs>
                <linearGradient id="paint0_linear_2_459" x1="53.9604" y1="2" x2="2.19124" y2="28.3221" gradientUnits="userSpaceOnUse">
                <stop stop-color="#587DFF" stop-opacity="0"/>
                <stop offset="0.535704" stop-color="#587DFF"/>
                <stop offset="1" stop-color="#587DFF" stop-opacity="0"/>
                </linearGradient>
                </defs>
                </svg>
                <div className="chart-box-content">
                  <p>Total Raize</p>
                  <p class="price-chart"><span>{data.TotalRaize}</span> {data.Currency}</p>
                </div>
                </div>
                </Col>

                <Col md={12}>
                <div className="chart-box">

                <div className="progress-bar-row">
                <p className="pr-percent">{(data.CurrentRaize/data.TotalRaize * 100).toFixed(2)}%</p>
                <ProgressBar now={data.CurrentRaize/data.TotalRaize * 100} />
                </div> 
                <div className="chart-box-content">
                <p>Status</p>
                <p class="price-chart"><i class="fa fa-circle" aria-hidden="true"></i>{getDealStauts(data.Start,data.End)}</p>
                </div>
                </div>
                </Col>
                </Row>
                </div> {/* all deal closed  */}
                </div>

                <div className="about-joindeal">
                {/* <p className="brdr-ab"><a href="#">About</a> </p> */}
                <p><a href={"https://bulknetwork.app/contribute/"+data.id}>View Deal</a> </p> 
                </div>

                </div>
              {/* ====================  all deal closed ==================== */}
              </div>
          )
        })}  
        </OwlCarousel>
        </>
      }
  <div className="see-all-buttn"><a href="https://bulknetwork.app/" target="_blank"><button className="cnt-button">See all</button></a></div>
  </div>

  </Tab>
  {/* ============================ upcoming closed ====================================== */}

  <Tab eventKey="finished" title="Finished">

  <div className="book-slider-main">
      {allPublicDeals.length===0?
        <><p>No deals available....</p></>
        :
        <>
        <OwlCarousel className='owl-theme user-book' key={allPublicDeals.length} {...project} >
        {allPublicDeals.map((data, key) => {
          return(
              <div class='item'>
                <div className="all-deal-box home-deal-box">
                  <div className="cnt-box">
                <Row className=" header-chart align-items-center">
                  <Col md={12}>
                  <div className="user-name-row dl-dt">
                    <GetDealLogo id={data.id}/>
                  <div>
                  <p>{data.Name} </p>
                  <p className="small-text">{data.Ticker}</p>
                  </div>
                  </div> 
                  </Col>
                </Row>
                <Row >
                  <Col md={12}>
                  <div class="deal-info">
                  <ul>
                  <li><span className='text-heading'>Max Allocation</span> <span>{data.AllocationForTier1} {data.Currency}</span></li>  
                  <li><span className='text-heading'>Min Allocation</span>  <span>{data.AllocationForTier4} {data.Currency}</span></li>  
                  </ul>
                  </div>  
                  </Col> 
                </Row>
                <div className="deal-box-inner">
                <Row>
                <Col md={12}>
                <div className="chart-box">
                <svg width="56" height="30" viewBox="0 0 56 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 28C4.41676 25.3389 7.63911 18.2204 13.2782 18.0208C18.9173 17.8212 23.1467 24.8066 28.9872 24.8066C34.8277 24.8066 37.4358 13.3385 44.6961 8.04155C48.107 5.55309 54.5646 0.457338 53.9604 2.45318" stroke="url(#paint0_linear_2_459)" stroke-width="3"/>
                <defs>
                <linearGradient id="paint0_linear_2_459" x1="53.9604" y1="2" x2="2.19124" y2="28.3221" gradientUnits="userSpaceOnUse">
                <stop stop-color="#587DFF" stop-opacity="0"/>
                <stop offset="0.535704" stop-color="#587DFF"/>
                <stop offset="1" stop-color="#587DFF" stop-opacity="0"/>
                </linearGradient>
                </defs>
                </svg>
                <div className="chart-box-content">
                  <p>Total Raize</p>
                  <p class="price-chart"><span>{data.TotalRaize}</span> {data.Currency}</p>
                </div>
                </div>
                </Col>

                <Col md={12}>
                <div className="chart-box">

                <div className="progress-bar-row">
                <p className="pr-percent">{(data.CurrentRaize/data.TotalRaize * 100).toFixed(2)}%</p>
                <ProgressBar now={data.CurrentRaize/data.TotalRaize * 100} />
                </div> 
                <div className="chart-box-content">
                <p>Status</p>
                <p class="price-chart"><i class="fa fa-circle" aria-hidden="true"></i>{getDealStauts(data.Start,data.End)}</p>
                </div>
                </div>
                </Col>
                </Row>
                </div> {/* all deal closed  */}
                </div>

                <div className="about-joindeal">
                {/* <p className="brdr-ab"><a href="#">About</a> </p> */}
                <p><a href={"https://bulknetwork.app/contribute/"+data.id}>View Deal</a> </p> 
                </div>

                </div>
              {/* ====================  all deal closed ==================== */}
              </div>
          )
        })}  
        </OwlCarousel>
        </>
      }
  <div className="see-all-buttn"><a href="https://bulknetwork.app/" target="_blank"><button className="cnt-button">See all</button></a></div>
  </div>

  </Tab>
  {/* ============================ upcoming closed ====================================== */}

</Tabs>


</Container>
</section>

<section className="bulk-section">
<Container>
<div className="main-page-heading">
<p>has been active in the market since 2017</p>  
<h2>Bulk</h2>
</div>
<Row>
<Col md={4}>
<div className="bulk-box">
<div className="bulk-graph">
<svg width="171" height="167" viewBox="0 0 171 167" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.0284 33.1391C5.55061 46.8652 0 63.5111 0 81.4534C0 128.47 38.1148 166.585 85.1319 166.585C132.149 166.585 170.264 128.47 170.264 81.4534C170.264 44.0619 146.157 12.3007 112.638 0.863281L110.733 10.7961C139.623 21.2657 160.264 48.9491 160.264 81.4534C160.264 122.948 126.626 156.585 85.1319 156.585C43.6377 156.585 10 122.948 10 81.4534C10 64.957 15.3165 49.7024 24.3296 37.3095L15.0284 33.1391Z" fill="url(#paint0_linear_465_417)"/>
<defs>
<linearGradient id="paint0_linear_465_417" x1="1.30821e-06" y1="-1.85011" x2="119.01" y2="27.0431" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C96FB"/>
<stop offset="1" stop-color="#607DEA"/>
</linearGradient>
</defs>
</svg>
<p>100+</p>
</div>
<div className="content">
<p>More than 100 </p>
<p>projects</p>
</div>
</div>
</Col>

<Col md={4}>
<div className="bulk-box">
<div className="bulk-graph">
<svg width="158" height="171" viewBox="0 0 158 171" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M132.667 14.9851C121.343 7.42261 108.037 2.47487 93.5314 1.09008C46.7271 -3.37823 5.16256 30.9418 0.694251 77.746C-3.77405 124.55 30.546 166.115 77.3502 170.583C110.254 173.724 140.569 157.695 157.225 131.635L148.111 127.303C133.276 149.683 106.896 163.358 78.3006 160.628C36.9942 156.685 6.70555 120.003 10.649 78.6964C14.5924 37.39 51.2746 7.10138 92.581 11.0448C105.083 12.2384 116.576 16.4311 126.416 22.8435L132.667 14.9851Z" fill="url(#paint0_linear_465_423)"/>
<defs>
<linearGradient id="paint0_linear_465_423" x1="145.747" y1="6.07346" x2="100.482" y2="118.074" gradientUnits="userSpaceOnUse">
<stop stop-color="#EBA724"/>
<stop offset="1" stop-color="#FFD583"/>
</linearGradient>
</defs>
</svg>
<p className="orange-clr">$10M+</p>
</div>
<div className="content">
<p>$10.000.000+ </p>
<p>allocated</p>
</div>
</div>
</Col>

<Col md={4}>
<div className="bulk-box">
<div className="bulk-graph">
<svg width="171" height="170" viewBox="0 0 171 170" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 87.2206C1.4546 132.962 38.9931 169.597 85.0881 169.597C132.105 169.597 170.22 131.482 170.22 84.465C170.22 41.0745 137.758 5.26583 95.7953 0L94.623 9.93243C131.615 14.6175 160.22 46.2008 160.22 84.465C160.22 125.959 126.582 159.597 85.0881 159.597C45.6901 159.597 13.3749 129.272 10.2105 90.6902L0 87.2206Z" fill="url(#paint0_linear_465_428)"/>
<defs>
<linearGradient id="paint0_linear_465_428" x1="-3.44802e-06" y1="1.12962" x2="118.985" y2="30.0039" gradientUnits="userSpaceOnUse">
<stop stop-color="#7C6BDE"/>
<stop offset="1" stop-color="#A79AF6"/>
</linearGradient>
</defs>
</svg>
<p>
<svg width="70" height="39" viewBox="0 0 70 39" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M50.5758 0.020447C45.8176 0.00788841 41.2227 1.75359 37.672 4.92127C39.4387 7.02453 40.7956 9.44041 41.6732 12.043C43.7237 9.55744 46.7107 8.03083 49.9267 7.82584C53.1422 7.62037 56.2995 8.75468 58.6494 10.9594C60.9989 13.1638 62.3321 16.2426 62.3321 19.4647C62.3321 22.6868 60.9989 25.7656 58.6494 27.9699C56.2995 30.1748 53.1422 31.309 49.9267 31.1035C46.7107 30.8985 43.7238 29.3719 41.6732 26.8863C41.1351 26.2333 40.6725 25.522 40.2928 24.766C39.4046 23.1379 38.9243 21.3188 38.8927 19.4647C38.9128 15.263 37.5489 11.171 35.0115 7.82185C34.6287 7.27329 34.2008 6.75839 33.7311 6.28161C33.2965 5.80337 32.8354 5.34925 32.3512 4.92127C28.5936 1.58718 23.6923 -0.163965 18.6733 0.0354938C13.6543 0.234953 8.90621 2.36933 5.42487 5.99123C1.94418 9.61261 0 14.4412 0 19.4647C0 24.4882 1.94405 29.3166 5.42487 32.9381C8.90557 36.56 13.6532 38.6945 18.6733 38.8939C23.6933 39.0932 28.5941 37.3422 32.3512 34.0081C30.5845 31.9048 29.2276 29.4889 28.35 26.8863C26.2995 29.3719 23.3125 30.8985 20.0965 31.1035C16.881 31.309 13.7237 30.1747 11.3738 27.9699C9.02426 25.7656 7.69106 22.6868 7.69106 19.4647C7.69106 16.2426 9.02426 13.1638 11.3738 10.9594C13.7237 8.75459 16.881 7.62033 20.0965 7.82584C23.3125 8.0308 26.2994 9.55744 28.35 12.043C28.8881 12.6961 29.3507 13.4073 29.7304 14.1634C30.6186 15.7915 31.0989 17.6105 31.1305 19.4647C31.1104 23.6663 32.4743 27.7584 35.0117 31.1075C35.3945 31.656 35.8225 32.171 36.2921 32.6477C36.7322 33.1079 37.1923 33.5881 37.6725 34.0081H37.672C42.4558 38.2403 49.0134 39.8528 55.2144 38.3227C61.4159 36.7927 66.4699 32.3142 68.7354 26.3423C71.001 20.3704 70.1898 13.6667 66.5642 8.40775C62.9389 3.14916 56.9619 0.00604421 50.5741 0L50.5758 0.020447Z" fill="#A89AF6"/>
</svg>
</p>
</div>
<div className="content">
<p>Multiple</p>
<p>unicorn projects</p>
</div>
</div>
</Col>

</Row>
</Container>
</section> {/* bulk section closed */}

<section className="media-production">
<div className="media-left-graph-bg">
<img src={SupportGraph} />  
</div>
<Container>
<Row>
<Col lg={6} md={6}>
<div className="support-row">
<div className="support-box">

<svg className="svg-mp" width="200" height="300" viewBox="0 0 439 660" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.4" filter="url(#filter0_f_465_11)">
<circle cx="109" cy="330" r="130" fill="#7F68DB"/>
</g>
<defs>
<filter id="filter0_f_465_11" x="-221" y="0" width="660" height="660" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_465_11"/>
</filter>
</defs>
</svg>

<div className="content">
<div className="icon">
<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.3333 2.33333C10.3333 1.59695 10.9303 1 11.6667 1H14.3333C15.0697 1 15.6667 1.59695 15.6667 2.33333V3.09172C15.6667 3.66212 16.0495 4.15766 16.5763 4.37638C17.1033 4.59518 17.7169 4.51179 18.1204 4.1083L18.6568 3.57188C19.1775 3.05118 20.0217 3.05118 20.5424 3.57188L22.428 5.4575C22.9487 5.9782 22.9487 6.82242 22.428 7.34311L21.8917 7.87946C21.4882 8.28298 21.4048 8.89662 21.6236 9.42366C21.8423 9.95049 22.3379 10.3333 22.9083 10.3333L23.6667 10.3333C24.403 10.3333 25 10.9303 25 11.6667V14.3333C25 15.0697 24.403 15.6667 23.6667 15.6667H22.9083C22.3379 15.6667 21.8423 16.0495 21.6236 16.5763C21.4048 17.1033 21.4882 17.717 21.8917 18.1205L22.4281 18.6568C22.9488 19.1775 22.9488 20.0217 22.4281 20.5424L20.5424 22.4281C20.0217 22.9488 19.1775 22.9488 18.6568 22.4281L18.1205 21.8917C17.717 21.4882 17.1033 21.4048 16.5763 21.6236C16.0495 21.8423 15.6667 22.3379 15.6667 22.9083V23.6667C15.6667 24.403 15.0697 25 14.3333 25H11.6667C10.9303 25 10.3333 24.403 10.3333 23.6667V22.9083C10.3333 22.3379 9.95049 21.8423 9.42366 21.6236C8.89662 21.4048 8.28298 21.4882 7.87946 21.8917L7.34309 22.4281C6.82239 22.9488 5.97817 22.9488 5.45747 22.4281L3.57186 20.5424C3.05116 20.0217 3.05116 19.1775 3.57186 18.6568L4.1083 18.1204C4.51179 17.7169 4.59518 17.1033 4.37638 16.5763C4.15766 16.0495 3.66212 15.6667 3.09172 15.6667H2.33333C1.59695 15.6667 1 15.0697 1 14.3333V11.6667C1 10.9303 1.59695 10.3333 2.33333 10.3333L3.09169 10.3333C3.6621 10.3333 4.15767 9.9505 4.37639 9.42369C4.5952 8.89667 4.51181 8.28305 4.10831 7.87955L3.57188 7.34312C3.05118 6.82242 3.05118 5.9782 3.57188 5.4575L5.4575 3.57188C5.9782 3.05118 6.82242 3.05118 7.34312 3.57188L7.87954 4.10831C8.28304 4.51181 8.89667 4.5952 9.42368 4.37639C9.9505 4.15767 10.3333 3.6621 10.3333 3.09169V2.33333Z" stroke="#607DEA" stroke-width="1.5"/>
<path d="M15.6667 13C15.6667 14.4728 14.4728 15.6667 13 15.6667C11.5272 15.6667 10.3333 14.4728 10.3333 13C10.3333 11.5272 11.5272 10.3333 13 10.3333C14.4728 10.3333 15.6667 11.5272 15.6667 13Z" stroke="#607DEA" stroke-width="1.5"/>
</svg>
</div>
<h5>Support</h5>
<p>We are actively producing content across Telegram, YouTube & Twitter in order to support promising 
teams and introduce their ideas and vision to our audience.</p>
</div>
</div> {/* support box closed   */}

<div className="support-box partnership-box">
<div className="content">
<div className="icon">
<svg width="34" height="22" viewBox="0 0 34 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.2857 21V19.5714C25.2857 16.4155 22.7273 13.8571 19.5714 13.8571H13.8571C10.7012 13.8571 8.14286 16.4155 8.14286 19.5714V21M32.4286 21V19.5714C32.4286 16.4155 29.8702 13.8571 26.7143 13.8571H26M1 21V19.5714C1 16.4155 3.55837 13.8571 6.71429 13.8571H7.42857M23.8571 9.57143C26.2241 9.57143 28.1429 7.65265 28.1429 5.28571C28.1429 2.91878 26.2241 1 23.8571 1M9.57143 9.57143C7.20449 9.57143 5.28571 7.65265 5.28571 5.28571C5.28571 2.91878 7.20449 1 9.57143 1M21 5.28571C21 7.65265 19.0812 9.57143 16.7143 9.57143C14.3474 9.57143 12.4286 7.65265 12.4286 5.28571C12.4286 2.91878 14.3474 1 16.7143 1C19.0812 1 21 2.91878 21 5.28571Z" stroke="#A89AF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</div>
<h5>Partnerships</h5>
<p>Partnerships with top influencers with tens of thousands of subscribers across different platforms.</p>
</div>
</div> {/* support box closed   */}

</div>
</Col>

<Col lg={6} md={6} className="market-media-cnt">
<div className="content">
<div className="main-page-heading">
<p>Support, partnership </p>  
<h2>Media production and marketing</h2>
</div> 
<div className="bottom-content">
<p>
Together we work on your marketing exposure and on building a high-quality community 
that will become a true backbone of your project.  
</p>
</div>
</div>
</Col>
</Row>
</Container>
</section>  {/* media production  section closed */}


<section className="financial-seciton">
<img src={LineBg} className="right-ln" />

<Container>
<div className="main-page-heading">
<p>Experience</p>  
<h2>Financial contribution</h2>
</div> 

<div className="financial-box">
<div className="icon">
<svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M26.75 9.33333C26.75 8.91912 26.4142 8.58333 26 8.58333C25.5858 8.58333 25.25 8.91912 25.25 9.33333H26.75ZM25.25 14.8889C25.25 15.3031 25.5858 15.6389 26 15.6389C26.4142 15.6389 26.75 15.3031 26.75 14.8889H25.25ZM26.75 37.1111C26.75 36.6969 26.4142 36.3611 26 36.3611C25.5858 36.3611 25.25 36.6969 25.25 37.1111H26.75ZM25.25 42.6667C25.25 43.0809 25.5858 43.4167 26 43.4167C26.4142 43.4167 26.75 43.0809 26.75 42.6667H25.25ZM34.3333 15.6389C34.7475 15.6389 35.0833 15.3031 35.0833 14.8889C35.0833 14.4747 34.7475 14.1389 34.3333 14.1389V15.6389ZM23.2222 14.8889V14.1389V14.8889ZM28.7778 37.1111V36.3611V37.1111ZM17.6667 36.3611C17.2525 36.3611 16.9167 36.6969 16.9167 37.1111C16.9167 37.5253 17.2525 37.8611 17.6667 37.8611V36.3611ZM28.7778 26V25.25V26ZM23.2222 26V25.25V26ZM21.0962 15.3118L20.8092 14.6189L21.0962 15.3118ZM18.0896 18.3184L17.3966 18.0314L18.0896 18.3184ZM18.0896 22.5705L17.3966 22.8575L18.0896 22.5705ZM19.2939 24.3728L19.8242 23.8425L19.2939 24.3728ZM21.0962 25.5771L20.8092 26.27L21.0962 25.5771ZM30.9038 36.6882L31.1908 37.3811L30.9038 36.6882ZM33.9104 33.6816L34.6034 33.9686L33.9104 33.6816ZM33.9104 29.4295L34.6034 29.1425L33.9104 29.4295ZM32.7061 27.6272L32.1758 28.1575L32.7061 27.6272ZM30.9038 26.4229L31.1908 25.73L30.9038 26.4229ZM50.25 26C50.25 39.3929 39.3929 50.25 26 50.25V51.75C40.2213 51.75 51.75 40.2213 51.75 26H50.25ZM26 50.25C12.6071 50.25 1.75 39.3929 1.75 26H0.25C0.25 40.2213 11.7787 51.75 26 51.75V50.25ZM1.75 26C1.75 12.6071 12.6071 1.75 26 1.75V0.25C11.7787 0.25 0.25 11.7787 0.25 26H1.75ZM26 1.75C39.3929 1.75 50.25 12.6071 50.25 26H51.75C51.75 11.7787 40.2213 0.25 26 0.25V1.75ZM25.25 9.33333V14.8889H26.75V9.33333H25.25ZM25.25 37.1111V42.6667H26.75V37.1111H25.25ZM34.3333 14.1389H23.2222V15.6389H34.3333V14.1389ZM28.7778 36.3611H17.6667V37.8611H28.7778V36.3611ZM28.7778 25.25H23.2222V26.75H28.7778V25.25ZM23.2222 14.1389C22.3942 14.1389 21.5742 14.302 20.8092 14.6189L21.3832 16.0047C21.9663 15.7632 22.5911 15.6389 23.2222 15.6389V14.1389ZM20.8092 14.6189C20.0442 14.9358 19.349 15.4002 18.7635 15.9857L19.8242 17.0464C20.2704 16.6002 20.8002 16.2462 21.3832 16.0047L20.8092 14.6189ZM18.7635 15.9857C18.178 16.5713 17.7135 17.2664 17.3966 18.0314L18.7825 18.6054C19.024 18.0224 19.3779 17.4926 19.8242 17.0464L18.7635 15.9857ZM17.3966 18.0314C17.0798 18.7964 16.9167 19.6164 16.9167 20.4444H18.4167C18.4167 19.8134 18.541 19.1885 18.7825 18.6054L17.3966 18.0314ZM16.9167 20.4444C16.9167 21.2725 17.0798 22.0924 17.3966 22.8575L18.7825 22.2835C18.541 21.7004 18.4167 21.0755 18.4167 20.4444H16.9167ZM17.3966 22.8575C17.7135 23.6225 18.178 24.3176 18.7635 24.9031L19.8242 23.8425C19.3779 23.3962 19.024 22.8665 18.7825 22.2835L17.3966 22.8575ZM18.7635 24.9031C19.349 25.4887 20.0442 25.9531 20.8092 26.27L21.3832 24.8842C20.8002 24.6427 20.2704 24.2887 19.8242 23.8425L18.7635 24.9031ZM20.8092 26.27C21.5742 26.5869 22.3942 26.75 23.2222 26.75V25.25C22.5911 25.25 21.9663 25.1257 21.3832 24.8842L20.8092 26.27ZM28.7778 37.8611C29.6058 37.8611 30.4258 37.698 31.1908 37.3811L30.6168 35.9953C30.0337 36.2368 29.4089 36.3611 28.7778 36.3611V37.8611ZM31.1908 37.3811C31.9558 37.0642 32.651 36.5998 33.2365 36.0143L32.1758 34.9536C31.7296 35.3998 31.1998 35.7538 30.6168 35.9953L31.1908 37.3811ZM33.2365 36.0143C33.822 35.4287 34.2865 34.7336 34.6034 33.9686L33.2175 33.3946C32.976 33.9776 32.6221 34.5074 32.1758 34.9536L33.2365 36.0143ZM34.6034 33.9686C34.9202 33.2036 35.0833 32.3836 35.0833 31.5556H33.5833C33.5833 32.1866 33.459 32.8115 33.2175 33.3946L34.6034 33.9686ZM35.0833 31.5556C35.0833 30.7275 34.9202 29.9076 34.6034 29.1425L33.2175 29.7165C33.459 30.2996 33.5833 30.9245 33.5833 31.5556H35.0833ZM34.6034 29.1425C34.2865 28.3775 33.822 27.6824 33.2365 27.0969L32.1758 28.1575C32.6221 28.6037 32.976 29.1335 33.2175 29.7165L34.6034 29.1425ZM33.2365 27.0969C32.651 26.5113 31.9558 26.0469 31.1908 25.73L30.6168 27.1158C31.1998 27.3573 31.7296 27.7113 32.1758 28.1575L33.2365 27.0969ZM31.1908 25.73C30.4258 25.4131 29.6058 25.25 28.7778 25.25V26.75C29.4089 26.75 30.0337 26.8743 30.6168 27.1158L31.1908 25.73Z" fill="#FFD584"/>
</svg> 
</div> 
<div className="content">
<p>We have been supporting promising projects in their early development stages for over 4 years.</p>  
</div>
</div>

</Container>
</section>  


<section className="technical-support">

<img src={FC} className="fc"/>

<Container>
<Row>
<Col lg={5} md={5} className="tech-support-left">
<div className="content">
<div className="main-page-heading">
<p>We help you to start</p>  
<h2>Technical support</h2>
</div> 
<div className="content">
<p>All-round technical solutions and best practices brought to you by experts in the field.</p>  
</div>
</div>
</Col>

<Col lg={7} md={7} className="tech-support-right">
<div className="content">

<div className="tech-support-box">
<div className="icon">
<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 12.75C1.5 6.5368 6.5368 1.5 12.75 1.5C18.9632 1.5 24 6.5368 24 12.75C24 18.9632 18.9632 24 12.75 24C6.5368 24 1.5 18.9632 1.5 12.75ZM12.75 0C5.70837 0 0 5.70837 0 12.75C0 19.7916 5.70837 25.5 12.75 25.5C19.7916 25.5 25.5 19.7916 25.5 12.75C25.5 5.70837 19.7916 0 12.75 0ZM11.2803 10.2803C11.5732 9.98744 11.5732 9.51256 11.2803 9.21967C10.9874 8.92678 10.5126 8.92678 10.2197 9.21967L7.21967 12.2197C6.92678 12.5126 6.92678 12.9874 7.21967 13.2803L10.2197 16.2803C10.5126 16.5732 10.9874 16.5732 11.2803 16.2803C11.5732 15.9874 11.5732 15.5126 11.2803 15.2197L8.81066 12.75L11.2803 10.2803ZM15.2803 9.21967C14.9874 8.92678 14.5126 8.92678 14.2197 9.21967C13.9268 9.51256 13.9268 9.98744 14.2197 10.2803L16.6893 12.75L14.2197 15.2197C13.9268 15.5126 13.9268 15.9874 14.2197 16.2803C14.5126 16.5732 14.9874 16.5732 15.2803 16.2803L18.2803 13.2803C18.421 13.1397 18.5 12.9489 18.5 12.75C18.5 12.5511 18.421 12.3603 18.2803 12.2197L15.2803 9.21967Z" fill="#607DEA"/>
</svg>
</div>
<div className="content">
<p>
Our community members have extensive experience in running validator nodes. Being a <span>geographically dispersed community</span>, 
we are able to test networks from all over the world in various set-ups.

</p>
</div>
</div>

<div className="tech-support-box sup-border">
<div className="icon">
<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.5 1V26M1 13.5L26 13.5M23.2222 13.5C23.2222 18.8694 18.8694 23.2222 13.5 23.2222C8.13056 23.2222 3.77778 18.8694 3.77778 13.5C3.77778 8.13056 8.13056 3.77778 13.5 3.77778C18.8694 3.77778 23.2222 8.13056 23.2222 13.5Z" stroke="#FFD584" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</div>
<div className="content">
<p>
<span>Validator nodes. </span> We are operating nodes or have participated in the test nets of the following networks: Polkadot, 
Hopr Protocol, Nym, Crust Network, Plasm, Radicle, Casper, Keep Network.
</p>
</div>
</div>

<div className="tech-support-box sup-border">
<div className="icon">
<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 16.2941L0.46967 15.7638C0.329018 15.9044 0.25 16.0952 0.25 16.2941H1ZM16.2941 1L16.8244 0.46967C16.5316 0.176777 16.0567 0.176777 15.7638 0.46967L16.2941 1ZM21 5.70588L21.5303 6.23621C21.8232 5.94332 21.8232 5.46845 21.5303 5.17555L21 5.70588ZM5.70588 21V21.75C5.90479 21.75 6.09556 21.671 6.23621 21.5303L5.70588 21ZM1 21H0.25C0.25 21.4142 0.585786 21.75 1 21.75L1 21ZM10.4118 20.25C9.99755 20.25 9.66177 20.5858 9.66177 21C9.66177 21.4142 9.99755 21.75 10.4118 21.75V20.25ZM20.4118 21.75C20.826 21.75 21.1618 21.4142 21.1618 21C21.1618 20.5858 20.826 20.25 20.4118 20.25V21.75ZM1.53033 16.8244L16.8244 1.53033L15.7638 0.46967L0.46967 15.7638L1.53033 16.8244ZM15.7638 1.53033L20.4697 6.23621L21.5303 5.17555L16.8244 0.46967L15.7638 1.53033ZM20.4697 5.17555L5.17555 20.4697L6.23621 21.5303L21.5303 6.23621L20.4697 5.17555ZM5.70588 20.25H1V21.75H5.70588V20.25ZM1.75 21V16.2941H0.25V21H1.75ZM12.2344 5.05974L16.9403 9.76562L18.0009 8.70496L13.295 3.99908L12.2344 5.05974ZM10.4118 21.75H20.4118V20.25H10.4118V21.75Z" fill="#A89AF6"/>
</svg>
</div>
<div className="content">
<p>
<span>Translating technical documentation.</span> Written and video manuals.
</p>
</div>
</div>

<div className="tech-support-box sup-border">
<div className="icon">
<svg width="19" height="23" viewBox="0 0 19 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1V0.25C0.585786 0.25 0.25 0.585786 0.25 1L1 1ZM17.3333 22V22.75C17.7475 22.75 18.0833 22.4142 18.0833 22H17.3333ZM1 22H0.25C0.25 22.4142 0.585786 22.75 1 22.75L1 22ZM11.5 1L12.0303 0.46967C11.8897 0.329018 11.6989 0.25 11.5 0.25V1ZM17.3333 6.83333H18.0833C18.0833 6.63442 18.0043 6.44366 17.8637 6.303L17.3333 6.83333ZM13.1971 12.0303C13.49 11.7374 13.49 11.2626 13.1971 10.9697C12.9042 10.6768 12.4294 10.6768 12.1365 10.9697L13.1971 12.0303ZM7.76677 16.4L7.23644 16.9304C7.52933 17.2233 8.0042 17.2233 8.2971 16.9304L7.76677 16.4ZM6.19703 13.7697C5.90414 13.4768 5.42927 13.4768 5.13637 13.7697C4.84348 14.0626 4.84349 14.5375 5.13638 14.8304L6.19703 13.7697ZM17.3333 21.25H1V22.75H17.3333V21.25ZM1.75 22V1H0.25V22H1.75ZM1 1.75H11.5V0.25H1V1.75ZM16.5833 6.83333V22H18.0833V6.83333H16.5833ZM10.9697 1.53033L16.803 7.36366L17.8637 6.303L12.0303 0.46967L10.9697 1.53033ZM9.58333 1V5.66667H11.0833V1H9.58333ZM12.6667 8.75H17.3333V7.25H12.6667V8.75ZM9.58333 5.66667C9.58333 7.36954 10.9638 8.75 12.6667 8.75V7.25C11.7922 7.25 11.0833 6.54112 11.0833 5.66667H9.58333ZM12.1365 10.9697L7.23644 15.8697L8.2971 16.9304L13.1971 12.0303L12.1365 10.9697ZM5.13638 14.8304L7.23644 16.9304L8.29709 15.8697L6.19703 13.7697L5.13638 14.8304Z" fill="#D66C4A"/>
</svg>
</div>
<div className="content">
<p>
Smart contract  <span>audits.</span>
</p>
</div>
</div>


</div>
</Col>

</Row>  
</Container>  
</section>


<section className="advisory-section">
<Container>

<div className="main-page-heading">
<p>Complete scope of consulting and advisory services</p>  
<h2>Advisory services</h2>
</div> 

<Row>
<Col lg={4} md={4}>
<div className="advisory-box">
<div className="icon">
<svg width="104" height="54" viewBox="0 0 104 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 52C6.64762 46.8824 12.8444 33.193 23.6889 32.8092C34.5333 32.4254 42.6667 45.8589 53.8984 45.8589C65.1302 45.8589 70.1458 23.8049 84.108 13.6184C90.6672 8.83287 103.086 -0.966658 101.924 2.87151" stroke="url(#paint0_linear_465_177)" stroke-width="3"/>
<defs>
<linearGradient id="paint0_linear_465_177" x1="101.924" y1="2" x2="2.36777" y2="52.6194" gradientUnits="userSpaceOnUse">
<stop stop-color="#587DFF" stop-opacity="0"/>
<stop offset="0.535704" stop-color="#587DFF"/>
<stop offset="1" stop-color="#587DFF" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>
</div> {/* icon closed */}
<div className="content">
<p>DEX Liquidity provision</p>
</div>
</div>
</Col> 
<Col lg={4} md={4}>
<div className="advisory-box">
<div className="icon">
<svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.79261 12.1123C2.15021 17.0928 0 23.2335 0 29.8763C0 46.5132 13.4868 60 30.1237 60C46.7605 60 60.2474 46.5132 60.2474 29.8763C60.2474 14.5536 48.807 1.90291 34.002 0L33.5558 3.97609C46.3615 5.6566 56.2474 16.612 56.2474 29.8763C56.2474 44.3041 44.5514 56 30.1237 56C15.696 56 4 44.3041 4 29.8763C4 24.0204 5.92681 18.6144 9.18102 14.2579L5.79261 12.1123Z" fill="url(#paint0_linear_465_190)"/>
<defs>
<linearGradient id="paint0_linear_465_190" x1="-0.000424751" y1="-3.54753" x2="42.3949" y2="6.1059" gradientUnits="userSpaceOnUse">
<stop stop-color="#EBA724"/>
<stop offset="1" stop-color="#FFD583"/>
</linearGradient>
</defs>
</svg>
</div> {/* icon closed */}
<div className="content">
<p>Token metrics engineering</p>
</div>
</div>
</Col> 
<Col lg={4} md={4}>
<div className="advisory-box">
<div className="icon">
<svg width="54" height="77" viewBox="0 0 54 77" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="17" y="20" width="3" height="57" rx="1.5" fill="#7C6BDE"/>
<rect x="51" width="3" height="77" rx="1.5" fill="#7C6BDE"/>
<rect x="34" y="38" width="3" height="39" rx="1.5" fill="#7C6BDE"/>
<rect y="42" width="3" height="35" rx="1.5" fill="#7C6BDE"/>
</svg>
</div> {/* icon closed */}
<div className="content">
<p>Endorsement</p>
</div>
</div>
</Col> 
</Row>

</Container>  
</section>


<section className="faq-section">
<img src={LineBg} className="bg-faq" />
<Container>
<div className="main-page-heading">
<p>Your questions, our answers</p>  
<h2>FAQ</h2>
</div>

<div className="faq-content">
  <div>
    <button class="accordion">What is Bulk?</button>
    <div class="panel">
      <p> We position ourselves as a decentralized venture capital platform.<br/>
          We incubate projects, finance, support them and provide our 
              community the opportunity to invest in these very projects at an
              early stage along with us.
      </p>
    </div>
    <button class="accordion">Where can I get acquainted with the projects that you’ve supported and invested in?</button>
    <div class="panel">
      <p>The All Deals tab on the site and the Public Area of our app display some projects that we and our community have invested in at an early stage (seed / presale / private phases).
          <br/>
          However, due to confidentiality reasons, the vast majority of our deals are not posted in the public All Deals area. These deals are only accessible to our members in the Member Area.
      </p>
    </div>
    <button class="accordion">How can I access the Member’s Area?</button>
    <div class="panel">
      <p>Our Member’s Area has a tiered system. Higher Tiers grant larger individual allocations and provide access to more exclusive deals that might not be accessible in lower Tiers.
        <br/>
        To access Member’s Area you need to lock the following number of tokens on our Lock Platform bulklock.web.app:<br/>
        Top 10 - 10 users with highest locked balances<br/>
        Tier 1 - 1 000 000 BULK<br/>
        Tier 2 - 500 000 BULK<br/>
        Tier 3 - 100 000 BULK<br/>
        Tier 4 - 10 000 BULK<br/>
        You can find the user manual <a href="https://crypto-bulk-intl.medium.com/how-to-join-bulk-community-7759b722ac21">here</a>.
      </p>
    </div>
    <button class="accordion">Is there a guaranteed allocation for the Tier 4 members?</button>
    <div class="panel">
      <p>Depending on a deal, Tier 4 can have either a guaranteed allocation or a limited number of allocations that can be raffled among participants. Lower tiers are sometimes excluded from the deals higher tiers take part in.</p>
    </div>
    <button class="accordion">How often are new deals posted?</button>
    <div class="panel">
      <p>All the important information concerning the past and new deals is posted in our Deal Announcements Channel in <a href="https://t.me/BulkDealsAnn">Telegram</a>. You can track new deal postings for each Tier on this channel.</p>
    </div>
  </div>
</div>
</Container>
</section>


<section className="partner-section">
<img src={ParnterBg} className="bg" />
<Container>
<div className="main-page-heading">
<p>Stronger together</p>  
<h2>Partners & investors</h2>
</div>
</Container>

<div className="partner-slider">
<OwlCarousel className='owl-theme user-book' 
{...partner}
>
<div class='item'> <a href="https://www.tenzor.capital/" target="_blank"><img src={P1} /> </a></div>
<div class='item'> <a href="https://zbs.capital/" target="_blank"><img src={P2} /> </a></div>
<div class='item'> <a href="https://a2dao.com/" target="_blank"><img src={P3} /> </a></div>
<div class='item'> <a href="https://spacemind.group/" target="_blank"><img src={P4} /> </a></div>
<div class='item'> <a href="https://tixl.org/" target="_blank"><img src={P5} /> </a></div>
<div class='item'> <a href="https://dexe.network/" target="_blank"><img src={P6} /> </a></div>
<div class='item'> <a href="https://www.hapi.one/" target="_blank"><img src={P7} /> </a></div>
<div class='item'> <a href="http://twitter.com/top7ico" target="_blank"><img src={P8} /> </a></div>
<div class='item'> <a href="http://bring.finance/" target="_blank"><img src={P9} /> </a></div>
<div class='item'> <a href="https://incrypted.net/" target="_blank"><img src={P10} /> </a></div>
<div class='item'> <a href="https://doubletop.io/" target="_blank"><img src={P11} /> </a></div>
<div class='item'> <a href="https://cryptodiffer.com/" target="_blank"><img src={P12} /> </a></div>

</OwlCarousel>
</div>
</section>


<footer>
 <Container fluid>
<div className="footer-contain">
<div className="footer-left">
<ul>
<li><a href="https://bulklock.web.app/">Platform</a></li> 
<li><a href="https://drive.google.com/file/d/1V0f95QD0Fb5MM9aZeGHhNzQHisXxJDRf/view">Pitch Deck</a></li> 
<li><a href="https://crosschainbridge.org/#/bridge">ETH BSC Bridge</a></li> 
<li><a href="https://t.me/Bulk_Nation">Community</a></li> 
<li><a href="mailto:info@bulknetwork.xyz">Contact</a></li> 
</ul>
</div> {/* left content closed */}

<div className="footer-right">
<ul>
<li><p>English</p></li>  
<li><a href="https://t.me/BulkNetworkIntl" target="_blank">
<svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.9593 1.67502L19.5883 19.6902C19.3827 20.5387 18.4313 20.9758 17.6514 20.5729L12.1231 17.719L9.50913 21.9956C8.79788 23.1613 6.99807 22.6557 6.99807 21.2928V16.5275C6.99807 16.1591 7.15226 15.8076 7.41799 15.5505L18.1914 5.26591C18.1828 5.13736 18.0456 5.02602 17.9086 5.12014L5.05285 14.0677L0.733365 11.8394C-0.277856 11.3166 -0.235004 9.85096 0.810461 9.39682L22.1084 0.115207C23.1283 -0.330538 24.2254 0.586585 23.9597 1.67494L23.9593 1.67502Z" fill="white"/>
</svg> 
</a>
</li> 
<li><a href="https://t.me/Bulk_Nation" target="_blank">
<svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.9593 1.67502L19.5883 19.6902C19.3827 20.5387 18.4313 20.9758 17.6514 20.5729L12.1231 17.719L9.50913 21.9956C8.79788 23.1613 6.99807 22.6557 6.99807 21.2928V16.5275C6.99807 16.1591 7.15226 15.8076 7.41799 15.5505L18.1914 5.26591C18.1828 5.13736 18.0456 5.02602 17.9086 5.12014L5.05285 14.0677L0.733365 11.8394C-0.277856 11.3166 -0.235004 9.85096 0.810461 9.39682L22.1084 0.115207C23.1283 -0.330538 24.2254 0.586585 23.9597 1.67494L23.9593 1.67502Z" fill="white"/>
</svg> 
</a>
</li>
<li><a href="https://www.youtube.com/channel/UCXwQdUYqe_zazMfyBcYa1tw" target="_blank">
<svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.9383 0H4.06141H4.06167C2.98431 0 1.95125 0.4278 1.18965 1.18965C0.42778 1.95125 0 2.98431 0 4.06167V12.554V12.5537C0 13.6311 0.4278 14.6641 1.18965 15.4257C1.95125 16.1876 2.98431 16.6154 4.06167 16.6154H19.9386H19.9383C21.0157 16.6154 22.0487 16.1876 22.8104 15.4257C23.5722 14.6641 24 13.6311 24 12.5537V4.06141V4.06167C24 2.98431 23.5722 1.95125 22.8104 1.18965C22.0487 0.42778 21.0157 0 19.9383 0ZM16.7004 8.46989L9.50038 12.1622C9.4432 12.1916 9.37495 12.1895 9.32009 12.1563C9.26497 12.1233 9.23123 12.0638 9.23071 11.9997V4.61506C9.23123 4.55093 9.26497 4.49144 9.32009 4.45847C9.37495 4.42525 9.4432 4.42319 9.50038 4.45255L16.7004 8.14485C16.7619 8.17653 16.8008 8.23989 16.8008 8.30917C16.8008 8.37846 16.7619 8.44181 16.7004 8.47349V8.46989Z" fill="white"/>
</svg> 
</a></li>
<li><a href="https://twitter.com/BulkNetwork" target="_blank">
<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M24 2.30941C23.1156 2.69969 22.1668 2.96464 21.1714 3.0828C22.1883 2.47412 22.9688 1.50738 23.334 0.358049C22.3816 0.923765 21.329 1.33194 20.2083 1.55393C19.3096 0.597941 18.0313 0 16.6135 0C13.8959 0 11.6903 2.20558 11.6903 4.92317C11.6903 5.30986 11.7333 5.68581 11.8192 6.04386C7.72669 5.83977 4.09966 3.87767 1.67209 0.898702C1.24959 1.62554 1.00612 2.47054 1.00612 3.37282C1.00612 5.08071 1.87617 6.5881 3.19737 7.46889C2.39176 7.44383 1.6327 7.22184 0.966731 6.85305C0.966731 6.87453 0.966731 6.89244 0.966731 6.91392C0.966731 9.29852 2.66388 11.2893 4.91601 11.7404C4.50425 11.8514 4.06743 11.9123 3.61987 11.9123C3.30121 11.9123 2.99329 11.8801 2.69253 11.8228C3.31911 13.7777 5.138 15.2027 7.28987 15.2421C5.60346 16.5633 3.48381 17.351 1.1744 17.351C0.776966 17.351 0.386693 17.326 0 17.283C2.17694 18.6794 4.76563 19.4957 7.54767 19.4957C16.6027 19.4957 21.5545 11.9946 21.5545 5.48889C21.5545 5.27406 21.5509 5.06281 21.5402 4.85156C22.5034 4.15694 23.3376 3.29047 23.9964 2.30225L24 2.30941Z" fill="white"/>
</svg> 
</a></li>
<li><a href="mailto:info@bulknetwork.xyz"><i class="fa fa-envelope"></i></a>  </li>
</ul>

<ul>
<li><p>Russian</p></li>  
<li><a href="https://t.me/BulkNetwork" target="_blank">
<svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.9593 1.67502L19.5883 19.6902C19.3827 20.5387 18.4313 20.9758 17.6514 20.5729L12.1231 17.719L9.50913 21.9956C8.79788 23.1613 6.99807 22.6557 6.99807 21.2928V16.5275C6.99807 16.1591 7.15226 15.8076 7.41799 15.5505L18.1914 5.26591C18.1828 5.13736 18.0456 5.02602 17.9086 5.12014L5.05285 14.0677L0.733365 11.8394C-0.277856 11.3166 -0.235004 9.85096 0.810461 9.39682L22.1084 0.115207C23.1283 -0.330538 24.2254 0.586585 23.9597 1.67494L23.9593 1.67502Z" fill="white"/>
</svg> 
</a>
</li>
<li><a href="https://t.me/Bulk_Republic" target="_blank">
<svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.9593 1.67502L19.5883 19.6902C19.3827 20.5387 18.4313 20.9758 17.6514 20.5729L12.1231 17.719L9.50913 21.9956C8.79788 23.1613 6.99807 22.6557 6.99807 21.2928V16.5275C6.99807 16.1591 7.15226 15.8076 7.41799 15.5505L18.1914 5.26591C18.1828 5.13736 18.0456 5.02602 17.9086 5.12014L5.05285 14.0677L0.733365 11.8394C-0.277856 11.3166 -0.235004 9.85096 0.810461 9.39682L22.1084 0.115207C23.1283 -0.330538 24.2254 0.586585 23.9597 1.67494L23.9593 1.67502Z" fill="white"/>
</svg> 
</a>
</li>
<li><a href="https://www.youtube.com/channel/UCv-Gi3U3bjYJDwo9dOM2NMA" target="_blank">
<svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.9383 0H4.06141H4.06167C2.98431 0 1.95125 0.4278 1.18965 1.18965C0.42778 1.95125 0 2.98431 0 4.06167V12.554V12.5537C0 13.6311 0.4278 14.6641 1.18965 15.4257C1.95125 16.1876 2.98431 16.6154 4.06167 16.6154H19.9386H19.9383C21.0157 16.6154 22.0487 16.1876 22.8104 15.4257C23.5722 14.6641 24 13.6311 24 12.5537V4.06141V4.06167C24 2.98431 23.5722 1.95125 22.8104 1.18965C22.0487 0.42778 21.0157 0 19.9383 0ZM16.7004 8.46989L9.50038 12.1622C9.4432 12.1916 9.37495 12.1895 9.32009 12.1563C9.26497 12.1233 9.23123 12.0638 9.23071 11.9997V4.61506C9.23123 4.55093 9.26497 4.49144 9.32009 4.45847C9.37495 4.42525 9.4432 4.42319 9.50038 4.45255L16.7004 8.14485C16.7619 8.17653 16.8008 8.23989 16.8008 8.30917C16.8008 8.37846 16.7619 8.44181 16.7004 8.47349V8.46989Z" fill="white"/>
</svg> 
</a></li>
<li><a href="https://twitter.com/BulkNetwork" target="_blank">
<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M24 2.30941C23.1156 2.69969 22.1668 2.96464 21.1714 3.0828C22.1883 2.47412 22.9688 1.50738 23.334 0.358049C22.3816 0.923765 21.329 1.33194 20.2083 1.55393C19.3096 0.597941 18.0313 0 16.6135 0C13.8959 0 11.6903 2.20558 11.6903 4.92317C11.6903 5.30986 11.7333 5.68581 11.8192 6.04386C7.72669 5.83977 4.09966 3.87767 1.67209 0.898702C1.24959 1.62554 1.00612 2.47054 1.00612 3.37282C1.00612 5.08071 1.87617 6.5881 3.19737 7.46889C2.39176 7.44383 1.6327 7.22184 0.966731 6.85305C0.966731 6.87453 0.966731 6.89244 0.966731 6.91392C0.966731 9.29852 2.66388 11.2893 4.91601 11.7404C4.50425 11.8514 4.06743 11.9123 3.61987 11.9123C3.30121 11.9123 2.99329 11.8801 2.69253 11.8228C3.31911 13.7777 5.138 15.2027 7.28987 15.2421C5.60346 16.5633 3.48381 17.351 1.1744 17.351C0.776966 17.351 0.386693 17.326 0 17.283C2.17694 18.6794 4.76563 19.4957 7.54767 19.4957C16.6027 19.4957 21.5545 11.9946 21.5545 5.48889C21.5545 5.27406 21.5509 5.06281 21.5402 4.85156C22.5034 4.15694 23.3376 3.29047 23.9964 2.30225L24 2.30941Z" fill="white"/>
</svg> 
</a></li>
</ul>
</div> {/* left content closed */}
</div>
<p div className="bottom-footer">Bulk Network powered by United Themes™</p>

 </Container> 
</footer>

</div>
)
}

export default LandingPage;

